import http from '@core/fetch'
export default {
  getContent: body => {
    return http(`/hps/admin/merchant/agreement/signInfo`, {
      body
    })
  },
  agreeContract: body => {
    return http.post(`/hps/admin/merchant/agreement/sign`, {
      body
    })
  }
}
